"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
const IconAvatar = ({
  width,
  height
}) => /*#__PURE__*/_react.default.createElement("svg", {
  width: width,
  height: height,
  viewBox: "0 0 69 69",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("g", {
  id: "Home-Screen",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/_react.default.createElement("g", {
  id: "Group-12"
}, /*#__PURE__*/_react.default.createElement("circle", {
  id: "Oval",
  fill: "#285AFF",
  cx: "34.5",
  cy: "34.5",
  r: "34.5"
}), /*#__PURE__*/_react.default.createElement("g", {
  id: "Group-11",
  transform: "translate(11.000000, 11.000000)"
}, /*#__PURE__*/_react.default.createElement("ellipse", {
  id: "Oval",
  stroke: "#FFFFFF",
  strokeWidth: "2",
  cx: "23.5",
  cy: "23.5925926",
  rx: "23.5",
  ry: "23.5925926"
}), /*#__PURE__*/_react.default.createElement("circle", {
  id: "Oval",
  fill: "#FFFFFF",
  cx: "23.5",
  cy: "18.5",
  r: "9.5"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M28.7862425,28.3934875 C36.4277633,29.5614625 42,33.1965711 42,37.5 C42,42.7467051 33.7172679,47 23.5,47 C13.2827321,47 5,42.7467051 5,37.5 C5,33.1965711 10.5722367,29.5614625 18.2137575,28.3934875 C19.7242822,29.4082798 21.5430393,30 23.5,30 C25.3996691,30 27.1691081,29.4424188 28.6535865,28.4819871 Z",
  id: "Combined-Shape",
  fill: "#FFFFFF"
})))));
IconAvatar.propTypes = {
  width: _propTypes.default.string,
  height: _propTypes.default.string
};
IconAvatar.defaultProps = {
  width: '50',
  height: '50'
};
const _default = IconAvatar;
var _default2 = exports.default = _default;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(IconAvatar, "IconAvatar", "/Users/jake.clayton/frontend/ls-common-client/src/components/UserMenu/IconAvatar.js");
  reactHotLoader.register(_default, "default", "/Users/jake.clayton/frontend/ls-common-client/src/components/UserMenu/IconAvatar.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();